import React, {useState, useEffect} from "react";
import jwt_decode from "jwt-decode";
import { useNavigate } from "react-router-dom";

const SearchBar = () => {
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);
  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      const parts = token.split(".");

      if (parts.length === 3) {
        const payload = JSON.parse(atob(parts[1]));
        const userRole = payload.role;
        const decoded = jwt_decode(token);
        const user_name = decoded.user;
        setIsAdmin(userRole && userRole.toLowerCase().includes("admin"));
      } else {
        console.error("Invalid token format.");
      }
    } else {
      console.error("Token not found in localStorage.");
    }
  }, []);
  return (
    isAdmin?
    <div className="rp-flex" id="search"  onClick={() => {
      navigate("/Search");
    }}>
      <div className="col-md-12">
        <a className="search-custom">
          <i className="mr-15 fas fa-search" />
          <span className="mr-0">Search</span>
        </a>
      </div>
    </div>
    :""
  );
};

export default SearchBar;
